module.exports = __webpack_public_path__ + "static/media/expense_other_on.b2138d4f.png";